import { put, takeLatest } from 'redux-saga/effects';
import { DocumentsAPI } from 'api/document/document-core';
import { mergeTasksIntoCollection } from 'collections/tasks';
import { getDocTasks } from '../../actions';
import { setTasksLoading } from '../../slice';
function* getDocTasksManager(action) {
    const { payload } = action;
    yield put(setTasksLoading(true));
    try {
        const response = yield DocumentsAPI.getTasks(payload.projectId, payload.documentId);
        // Document tasks are a lite DTO (base row only): merge, never replace, so
        // an open task drawer keeps its detail-only fields.
        mergeTasksIntoCollection(response, {
            source: 'fetch'
        });
        yield put(setTasksLoading(false));
    } catch (unused) {
        yield put(setTasksLoading(false));
    }
}
export const watchGetDocTasks = function*() {
    yield takeLatest(getDocTasks.type, getDocTasksManager);
};
